import { createLucideIcon } from "lucide-react";

export const ChevronUp = createLucideIcon(
    "ChevronUp",
    [
        [
            "path",
            {
                d: "M6 15L11.2929 9.70715C11.6262 9.37381 11.7929 9.20715 12 9.20715C12.2071 9.20715 12.3738 9.37381 12.7071 9.70715L18 15",
                key: "1meucc",
            },
        ],
    ],
);
